<template>
    <div class="taskindex">
        <div class="body">
            <div class="info" @click="gorule"></div>
            <div class="item" v-for="item in list" :key="item.id"  @click="goDetail(item)">
                <img :src="item.imgurl"  alt="">

            </div>
            <div class="other"  v-if="list.length == 0">
                <img style="width:3rem;height:3.54rem" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230615/1686813158/338324.png" alt="">
            </div>
        </div>
        <van-dialog
            v-model="showRule"
            class="sports_item_rule_dialog rule"
            :show-confirm-button="false"
            close-on-click-overlay
            >
            <van-icon
                name="close"
                style="position:fixed;right:10px;"
                size=".4rem"
                @click="showRule=false"
            />
            <div
                class="rule"
            >
                <div v-html="remark"></div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import './index.less'
export default {
    data() {
        return {
            list: [],
            showRule: false,
            remark: ''
        }
    },
    mounted() {
        this.getlist()
    },
    methods: {
        gorule() {
            this.showRule = true
        },
        getlist() {
            this.$api.sports.getTastList().then(res=>{
                if(res.status === 200) {
                    this.list = res.data
                    this.remark = res.data.length>0?res.data[0].remark:''
                }
            })
        },
        goDetail(val) {
            this.$router.push({name:'task',params:{taskid:val.id,sportsid:val.sports_id}})
        }
    }
}
</script>